import { render, staticRenderFns } from "./b-ticket-traveller-details.vue?vue&type=template&id=0950811c&scoped=true"
import script from "./b-ticket-traveller-details.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-ticket-traveller-details.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./b-ticket-traveller-details.vue?vue&type=style&index=0&id=0950811c&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0950811c",
  null
  
)

export default component.exports